import React from 'react';
import TextDisplay from '../../../Forms/TextDisplay/TextDisplay';

const JsonViewer = (props) => {

    const jsonObject = JSON.parse(props.data.message);
    const display = JSON.stringify(jsonObject, null, "\t");

    return (
        <div className="app-crafted-content">
            <div className='app-crafted-title'>{props.config.PageTitle}</div>
            <div className='app-crafted-headertext'>
                <TextDisplay text={props.config.Text}></TextDisplay>
            </div>
            <pre>
                {display}
            </pre>
        </div>
    );
};
  
export default JsonViewer;